/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function CreditsSection() {
  return (
    <MKBox
      bgColor="#343434"
      borderRadius="xl"
      shadow="lg"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      mt={{ xs: 10, sm: 10, md: 10 }}
      mb={{ xs: 10, sm: 10, md: 10 }}
      mx={3}
    >
      <MKBox
        variant="gradient"
        bgColor="info"
        coloredShadow="secondary"
        borderRadius="lg"
        p={2}
        mx={2}
        mt={-3}
      >
        <MKTypography
          variant="h1"
          color="white"
          sx={{ overflowWrap: "break-word", textAlign: "center" }}
        >
          Credits
        </MKTypography>
      </MKBox>
      <MKBox p={3}>
        <MKTypography variant="body2" color="white" mb={3}>
          <strong>Unannounced MMORPG</strong> (PC/Consoles; Unreleased)
          <br />
          <strong>Redfall</strong> (PC/Xbox Series; May 2023)
          <br />
          <strong>Rune 2</strong> (PC, Nov 2019)
          <br />
          <strong>Survived By</strong> (PC, Dec 2018)
          <br />
          <strong>Super Wall Crash</strong> (iOS/Android, March 2016)
          <br />
          <strong>Don&apos;t Be Dinner</strong> (PC, Aug 2014)
        </MKTypography>
      </MKBox>
    </MKBox>
  );
}

export default CreditsSection;
